import { formatInTimeZone } from 'date-fns-tz';

/** Checks if time falls within 4 AM - 10 PM (inclusive) local time. More lax than server business hours check. */
export const isWithinBusinessHours = (date: Date, timezone: string) => {
  const localDate = formatInTimeZone(date, timezone, 'yyyy-MM-dd HH:mm');
  const [hourStr, minuteStr] = localDate.split(' ')[1].split(':');
  const localHour = Number(hourStr);
  const localMinute = Number(minuteStr);

  // Valid if hour is between 4 and 21 (inclusive), or exactly 22:00
  if (localHour < 4 || localHour > 22) return false;
  if (localHour === 22 && localMinute !== 0) return false;
  return true;
};
